import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Custom hook to ensure that the navigation item is re-rendered when the location changes.
 * 
 * This hook is necessary because the navigation item does not automatically re-render 
 * when the location changes. It serves as a workaround to ensure that users can navigate 
 * back to the previous page from the navigation item once they are inside the embedded content.
 * 
 * We are using location as the dependency to trigger a re-render of the navigation item.
 * since it has a key property that changes even when the pathname remains the same.
 * 
 * Also using the custom hook to have this comment and logic in one place for multiple place use.
 */
const useLocationRerenderNavItem = () => {
  const location = useLocation()
  const [locationKey, setLocationKey] = useState('')

  useEffect(() => {
      setLocationKey(location.key)
  }, [location])

  return locationKey
}

export default useLocationRerenderNavItem
